import {
  Button,
  Checkbox,
  ChevronDownIcon,
  Dialog,
  DropdownMenu,
  Flex,
  useIsMobileScreenSize,
  ExternalLinkIcon,
} from '@buffer-mono/popcorn'

import styles from './Footer.module.css'

import type { JSX } from 'react'

type FooterProps = {
  loading: boolean
  setFollowBuffer: (value: boolean) => void
  followBuffer: boolean
  onConfirmServer: () => void
  isValidServer: boolean
}

export function Footer({
  loading,
  setFollowBuffer,
  followBuffer,
  onConfirmServer,
  isValidServer,
}: FooterProps): JSX.Element {
  const isMobile = useIsMobileScreenSize()

  const followUsText = isMobile ? 'Follow us' : 'Follow us on Mastodon'

  return (
    <Dialog.Footer className={styles.footer} showSeparator={false}>
      <DropdownMenu className={styles.helpMenu}>
        <DropdownMenu.Trigger>
          <Button variant="tertiary" size="large" className={styles.helpButton}>
            Need Help
            <ChevronDownIcon />
          </Button>
        </DropdownMenu.Trigger>
        <DropdownMenu.Content align="start">
          <DropdownMenu.Item>
            <a
              className={styles.helpLink}
              href="https://support.buffer.com/articles/using-mastodon-with-buffer-owHRCwpxsR"
              target="_blank"
              rel="noopener noreferrer"
            >
              Using Mastodon with Buffer
              <ExternalLinkIcon />
            </a>
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu>
      <Flex align="center" justify="end" gap="sm" className={styles.actions}>
        <Checkbox
          id="followBuffer"
          name="mastodonFollowBuffer"
          defaultChecked
          checked={followBuffer}
          onChange={(): void => {
            setFollowBuffer(!followBuffer)
          }}
        >
          <span className={styles.followLabel}>{followUsText}</span>
        </Checkbox>

        <Button
          size="large"
          disabled={loading || !isValidServer}
          id="go-to-service"
          onClick={onConfirmServer}
        >
          {loading ? 'Redirecting...' : 'Continue'}
        </Button>
      </Flex>
    </Dialog.Footer>
  )
}
